export default "__VITE_ASSET__BeBI67kt__"